import { Link } from 'react-router-dom';
import GlitchTitle from '../components/GlitchTitle';

export default function NotFound() {
  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '2rem',
        padding: '6rem 1.5rem 2rem',
      }}
    >
      <GlitchTitle text="404" style={{ fontSize: 'clamp(4rem, 12vw, 10rem)' }} />
      <span className="subtitle">SEGNALE PERSO</span>
      <Link to="/hub" className="btn btn-secondary">
        TORNA AL CONTROL PANEL
      </Link>
    </div>
  );
}
